import { render, staticRenderFns } from "./home-content.vue?vue&type=template&id=62867406&scoped=true&"
import script from "./home-content.vue?vue&type=script&lang=js&"
export * from "./home-content.vue?vue&type=script&lang=js&"
import style0 from "./home-content.vue?vue&type=style&index=0&id=62867406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62867406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
